import { AccountConfigService } from './../../../services/account-config/account-config.service';
import { Component, OnInit, Input, HostBinding } from '@angular/core';
@Component({
  selector: 'ags-argalis-apps-profile-button',
  templateUrl: './profile-button.component.html',
  styleUrls: ['./profile-button.component.scss']
})
export class ProfileButtonComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() icon: string;

  public isHovering: boolean;

  constructor(private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }
}
